import {Component} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {SessionService} from '../../services/session.service';

@Component({
  selector: 'app-login',
  imports: [],
  template: ''
})
export class LoginComponent {
  constructor(authService: AuthService, sessionService: SessionService) {
    sessionService.setSession({ongoingLogin: true});
    authService.redirectToLogin()
  }
}
